export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-8.png?def072c3f9ddebece248a5e0cb021be3";